import { styled } from "styled-components";
import { MobileBarAnalytics } from "./MobileBarAnalytics";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../Hooks/Hooks";
import { selectMassagedTimeData } from "../../Redux/Data/DataSlice";
import { NameValuePair } from "../../Types/DataTypes";

const MobileBarAnalyticsContainer = styled.div`
    display: flex;
    height: 100%;
    margin-top: 10vh;
    align-items: center;
    width: 95vw;
    justify-content: space-around;
    @media screen and (min-width: ${(props) => props.theme.breakpoint}px) {
        display: none;
    }
`;

export const MobileBarAnalyticsDisplay = () => {
    const [max, setMax] = useState<number>();

    const massagedTimeData = useAppSelector(selectMassagedTimeData);

    useEffect(() => {
        setMax(
            Math.max(
                ...massagedTimeData.map((obj: NameValuePair) => {
                    return obj.value;
                })
            )
        );
    }, [massagedTimeData]);

    return (
        <MobileBarAnalyticsContainer>
            {massagedTimeData
                ? massagedTimeData.map(
                      (dataPoint: NameValuePair, idx: number) => {
                          return (
                              <MobileBarAnalytics
                                  key={idx}
                                  displayValue={true}
                                  max={max}
                                  percent={
                                      max ? (dataPoint.value / max) * 100 : 0
                                  }
                                  lowerBound=" "
                                  upperBound=" "
                                  label={dataPoint.name}
                                  width={4}
                              />
                          );
                      }
                  )
                : ""}
        </MobileBarAnalyticsContainer>
    );
};
